import { render, staticRenderFns } from "./ChickenlegList.vue?vue&type=template&id=bd09577c&scoped=true"
import script from "./ChickenlegList.vue?vue&type=script&lang=js"
export * from "./ChickenlegList.vue?vue&type=script&lang=js"
import style0 from "./ChickenlegList.vue?vue&type=style&index=0&id=bd09577c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd09577c",
  null
  
)

export default component.exports